












































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCenter } from "@/request/idr";
@Component({})
export default class Jihe extends Vue {
  @Prop()
  private report: any;
  private explainType: any = "苔质";
  private conclusionType: any = "苔质";
}
